export default {
  monthlyCostButtonColor: 'var(--teal)',
};
